import { render, staticRenderFns } from "./newVideoDetail.vue?vue&type=template&id=45a28a7c&scoped=true&"
import script from "./newVideoDetail.vue?vue&type=script&lang=js&"
export * from "./newVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./newVideoDetail.vue?vue&type=style&index=0&id=45a28a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a28a7c",
  null
  
)

export default component.exports